import {
  CART_GET_CART_LIST_REQUEST,
  CART_GET_CART_LIST_SUCCESS,
  CART_GET_CART_LIST_FAILURE,
  CART_DELETE_CARTS_REQUEST,
  CART_DELETE_CARTS_SUCCESS,
  CART_DELETE_CARTS_FAILURE,
  CART_APPLY_ORDER_DETAILS
} from './actionTypes';
import {
  CartApplyOrderDetails,
  ICartDeleteFailure,
  ICartDeleteRequest,
  ICartDeleteSucess,
  ICartGetCartListFailure,
  ICartGetCartListRequest,
  ICartGetCartListSucess
} from './models/types';

export const getCartList = {
  request: (): ICartGetCartListRequest => ({ type: CART_GET_CART_LIST_REQUEST }),
  success: (data): ICartGetCartListSucess => ({ type: CART_GET_CART_LIST_SUCCESS, data }),
  failure: (error): ICartGetCartListFailure => ({ type: CART_GET_CART_LIST_FAILURE, error })
};

export const deleteCarts = {
  request: (cartIdList): ICartDeleteRequest => ({ type: CART_DELETE_CARTS_REQUEST, cartIdList }),
  success: (data, deletedLength): ICartDeleteSucess => ({
    type: CART_DELETE_CARTS_SUCCESS,
    data,
    deletedLength
  }),
  failure: (error): ICartDeleteFailure => ({ type: CART_DELETE_CARTS_FAILURE, error })
};

export const applyOrderDetails = (orderDetails, callback): CartApplyOrderDetails => ({
  type: CART_APPLY_ORDER_DETAILS,
  orderDetails,
  callback
});
